import {BaseConverter} from "../../base/converters/base-converter.converter";
import {TransictionStateModel} from "../models/transiction-state.model";
import {TransictionState} from "../../shared/DTO/transictionState";
import {Injectable} from "@angular/core";
import {ProcessToConverter} from "./process-to.converter";
import {StateChangeToConverter} from "./state-change-to.converter";

@Injectable()
export class TransictionStateConverter extends BaseConverter<TransictionStateModel, TransictionState> {

  constructor(private processToConverter: ProcessToConverter, private stateChangeToConverter: StateChangeToConverter) {
    super();
  }

  convertToDto(model: TransictionStateModel): TransictionState {
    if (!model) {
      return;
    }
    return {
      processes: this.processToConverter.convertToDtoList(model.processes),
      state: model.state,
      stateChanges: this.stateChangeToConverter.convertToDtoList(model.stateChanges)
    };
  }

  convertToModel(dto: TransictionState): TransictionStateModel {
    if (!dto) {
      return;
    }
    let model: TransictionStateModel = new TransictionStateModel();
    model.processes = this.processToConverter.convertToModelList(dto.processes);
    model.state = dto.state;
    model.stateChanges = this.stateChangeToConverter.convertToModelList(dto.stateChanges);

    return model;
  }

}
